export default __webpack_public_path__ + "static/media/warning--divided-highway--g5.f5e120c6.png";